import { render, staticRenderFns } from "./SupplierFoodSale.vue?vue&type=template&id=04c658e8&"
import script from "./SupplierFoodSale.vue?vue&type=script&lang=js&"
export * from "./SupplierFoodSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports